"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventDateTime = exports.getCorrectWidth = exports.getDaysNum = void 0;
const index_1 = require("../index");
const constants_1 = require("../constants");
const Helper_1 = require("./Helper");
const LuxonHelper_1 = require("./LuxonHelper");
const getDaysNum = (calendarView) => {
    switch (calendarView) {
        case index_1.CALENDAR_VIEW.WEEK:
            return constants_1.SEVEN_DAYS;
        case index_1.CALENDAR_VIEW.THREE_DAYS:
            return constants_1.THREE_DAYS;
        case index_1.CALENDAR_VIEW.DAY:
            return constants_1.ONE_DAY;
        default:
            return constants_1.SEVEN_DAYS;
    }
};
exports.getDaysNum = getDaysNum;
const getCorrectWidth = (width, isMobile, selectedView) => {
    if (selectedView === index_1.CALENDAR_VIEW.WEEK ||
        selectedView === index_1.CALENDAR_VIEW.DAY ||
        selectedView === index_1.CALENDAR_VIEW.THREE_DAYS) {
        if (isMobile) {
            return width;
        }
        else {
            return width - constants_1.SCROLLBAR_WIDTH;
        }
    }
    return width;
};
exports.getCorrectWidth = getCorrectWidth;
const getEventDateTime = (event, config) => {
    const dateTimeStart = (0, LuxonHelper_1.parseToDateTime)(event.startAt, config.timezone, (0, Helper_1.isEventFloating)(event));
    const dateTimeEnd = (0, LuxonHelper_1.parseToDateTime)(event.endAt, config.timezone, (0, Helper_1.isEventFloating)(event));
    return {
        dateTimeStart,
        dateTimeEnd,
    };
};
exports.getEventDateTime = getEventDateTime;
